import Icon from '../Icon.vue'

Icon.register({
  'eps': {
    width: 20,
    height: 20,
    paths: [
      {
        d: 'M10 5.003V2.827l2.176 2.176H10zM13 3l-.997-.997-2-2H1a1 1 0 00-1 1v18a1 1 0 001 1h13a1 1 0 001-1v-3h-2v2H2v-16h6v4a1 1 0 001 1h4v2h2V5l-2-2z'
      },
      {
        d: 'M7.222 15.015V10.03h3.39v1.091H8.448v.834h1.849v1.093h-1.85v.875h2.165v1.093zm6.174-3.886h-.693v1.008h.694c.335 0 .531-.245.531-.504 0-.26-.196-.504-.532-.504m.057 2.107h-.75v1.78h-1.226v-4.987h1.976c1.107 0 1.702.785 1.702 1.604 0 .819-.595 1.603-1.701 1.603m3.836 1.821c-.765 0-1.389-.14-1.893-.658l.785-.784c.26.258.714.35 1.114.35.483 0 .714-.162.714-.449a.416.416 0 00-.098-.294c-.063-.063-.168-.112-.329-.133l-.603-.084c-.44-.063-.777-.21-1.002-.44-.23-.239-.342-.575-.342-1.003 0-.91.686-1.575 1.821-1.575.714 0 1.253.168 1.681.594l-.77.771c-.316-.316-.729-.294-.946-.294-.428 0-.603.245-.603.462 0 .063.022.154.098.231a.57.57 0 00.344.148l.602.084c.448.062.771.203.981.413.265.26.371.63.371 1.093 0 1.014-.876 1.568-1.926 1.568'
      }
    ]
  }
})
